import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Función auxiliar para convertir fecha ISO a YYYY-MM-DD
const formatDateForInput = (dateString) => {
	if (!dateString) return '';
	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return '';
		return date.toISOString().split('T')[0];
	} catch {
		return '';
	}
};

export function Education({ educations = [], onUpdate }) {
	const [modalOpen, setModalOpen] = useState(false);
	const [editingIndex, setEditingIndex] = useState(null);
	const [formData, setFormData] = useState({
		nivelEducacion: '',
		cursoTituloCarrera: '',
		universidadInstituto: '',
		estaEstudiando: false,
		fechaInicio: '',
		fechaFinalizacion: ''
	});

	const handleOpenModal = (index = null) => {
		if (index !== null) {
			// Editar educación existente
			const edu = educations[index];
			setFormData({
				nivelEducacion: edu.nivelEducacion || '',
				cursoTituloCarrera: edu.cursoTituloCarrera || '',
				universidadInstituto: edu.universidadInstituto || '',
				estaEstudiando: edu.estaEstudiando || false,
				fechaInicio: formatDateForInput(edu.fechaInicio),
				fechaFinalizacion: formatDateForInput(edu.fechaFinalizacion)
			});
			setEditingIndex(index);
		} else {
			// Nueva educación
			setFormData({
				nivelEducacion: '',
				cursoTituloCarrera: '',
				universidadInstituto: '',
				estaEstudiando: false,
				fechaInicio: '',
				fechaFinalizacion: ''
			});
			setEditingIndex(null);
		}
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setEditingIndex(null);
		setFormData({
			nivelEducacion: '',
			cursoTituloCarrera: '',
			universidadInstituto: '',
			estaEstudiando: false,
			fechaInicio: '',
			fechaFinalizacion: ''
		});
	};

	const handleSave = () => {
		if (!formData.nivelEducacion || !formData.cursoTituloCarrera || !formData.universidadInstituto || !formData.fechaInicio) {
			alert('Por favor completa los campos requeridos: Nivel de Educación, Curso/Título/Carrera, Universidad/Instituto y Fecha de Inicio');
			return;
		}

		const newEducation = {
			nivelEducacion: formData.nivelEducacion,
			cursoTituloCarrera: formData.cursoTituloCarrera,
			universidadInstituto: formData.universidadInstituto,
			estaEstudiando: formData.estaEstudiando,
			fechaInicio: formData.fechaInicio,
			fechaFinalizacion: formData.estaEstudiando ? null : (formData.fechaFinalizacion || null)
		};

		let updatedEducations;
		if (editingIndex !== null) {
			// Actualizar educación existente
			const existingEdu = educations[editingIndex];
			updatedEducations = [...educations];
			updatedEducations[editingIndex] = {
				...existingEdu,
				...newEducation
			};
		} else {
			// Agregar nueva educación
			updatedEducations = [...educations, newEducation];
		}

		if (onUpdate) {
			onUpdate(updatedEducations);
		}
		handleCloseModal();
	};

	const handleDelete = (index) => {
		if (window.confirm('¿Estás seguro de que deseas eliminar esta educación?')) {
			const updatedEducations = educations.filter((_, i) => i !== index);
			if (onUpdate) {
				onUpdate(updatedEducations);
			}
		}
	};

	const formatDateRange = (fechaInicio, fechaFinalizacion, estaEstudiando) => {
		if (!fechaInicio) return '';
		const startDate = new Date(fechaInicio);
		const startStr = startDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
		
		if (estaEstudiando) {
			return `${startStr} - Actualidad`;
		} else if (fechaFinalizacion) {
			const endDate = new Date(fechaFinalizacion);
			const endStr = endDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
			return `${startStr} - ${endStr}`;
		}
		return startStr;
	};

	return <div id="education_bx" className="job-bx bg-white m-b30">
		<div className="d-flex">
			<h5 className="m-b15">Educación</h5>
			<Link to={"#"} onClick={() => handleOpenModal(null)} className="site-button add-btn button-sm"><i className="bi bi-plus"></i> Agregar</Link>
		</div>
	

		{educations.length > 0 ? (
			<div className="row">
				<div className="col-lg-12 col-md-12 col-sm-12">
					{educations.map((edu, index) => (
						<div key={edu.id || index} className="clearfix m-b20">
							<div className='d-flex justify-content-between'>
								<label className="m-b0">{edu.cursoTituloCarrera || 'Sin título especificado'}</label>
								<div>
									<span onClick={() => handleOpenModal(index)} className="site-button add-btn button-sm mr-2"><i className="fa fa-pencil m-r5"></i> Editar</span>
									<span onClick={() => handleDelete(index)} className="site-button add-btn button-sm" style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}><i className="fa fa-trash m-r5"></i> Eliminar</span>
								</div>
							</div>
							<span className="clearfix font-13">{edu.universidadInstituto || 'Sin institución especificada'}</span>
							<span className="clearfix font-13">{formatDateRange(edu.fechaInicio, edu.fechaFinalizacion, edu.estaEstudiando)}</span>
							<span className="clearfix font-13">{edu.nivelEducacion || ''}</span>
						</div>
					))}
				</div>
			</div>
		) : (
			<>
				<p>Detalla la información concerniente a tus estudios profesionales</p>
			<p className="m-b0">No has agregado educación aún. Haz clic en "Agregar" para agregar una.</p>
			</>
		)}

		<Modal className="modal fade modal-bx-info editor" show={modalOpen} onHide={handleCloseModal}>
			<div className="modal-dialog my-0" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="EducationModalLongTitle">
							{editingIndex !== null ? 'Editar Educación' : 'Agregar Educación'}
						</h5>
						<button type="button" className="close" onClick={handleCloseModal}>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<form>
							<div className="row">
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Nivel de Educación *</label>
										<Form.Control 
											as="select"
											value={formData.nivelEducacion}
											onChange={(e) => setFormData({ ...formData, nivelEducacion: e.target.value })}
										>
											<option value="">Seleccione un nivel</option>
											<option value="Graduado">Graduado</option>
											<option value="Maestría">Maestría</option>
											<option value="Doctorado">Doctorado</option>
											<option value="Técnico">Técnico</option>
											<option value="Bachillerato">Bachillerato</option>
										</Form.Control>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Curso/título/carrera *</label>
										<input 
											type="text" 
											className="form-control" 
											placeholder="Introduce el nombre del curso/titulo/carrera" 
											value={formData.cursoTituloCarrera}
											onChange={(e) => setFormData({ ...formData, cursoTituloCarrera: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Universidad/Instituto *</label>
										<input 
											type="text" 
											className="form-control" 
											placeholder="Introduce la universidad/instituto donde realizaste tus estudios" 
											value={formData.universidadInstituto}
											onChange={(e) => setFormData({ ...formData, universidadInstituto: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>¿Estás actualmente estudiando aquí?</label>
										<div className="row">
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input 
														type="radio" 
														className="custom-control-input" 
														id="study_yes" 
														name="estaEstudiando" 
														checked={formData.estaEstudiando === true}
														onChange={() => setFormData({ ...formData, estaEstudiando: true, fechaFinalizacion: '' })}
													/>
													<label className="custom-control-label" htmlFor="study_yes">Sí</label>
												</div>
											</div>
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input 
														type="radio" 
														className="custom-control-input" 
														id="study_no" 
														name="estaEstudiando" 
														checked={formData.estaEstudiando === false}
														onChange={() => setFormData({ ...formData, estaEstudiando: false })}
													/>
													<label className="custom-control-label" htmlFor="study_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Fecha de Inicio *</label>
										<input 
											type="date" 
											className="form-control" 
											value={formData.fechaInicio}
											onChange={(e) => setFormData({ ...formData, fechaInicio: e.target.value })}
										/>
									</div>
								</div>
								{!formData.estaEstudiando && (
									<div className="col-lg-12 col-md-12">
										<div className="form-group">
											<label>Fecha de Finalización</label>
											<input 
												type="date" 
												className="form-control" 
												value={formData.fechaFinalizacion}
												onChange={(e) => setFormData({ ...formData, fechaFinalizacion: e.target.value })}
											/>
										</div>
									</div>
								)}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="site-button" onClick={handleCloseModal}>Cancelar</button>
						<button type="button" className="site-button" onClick={handleSave}>Guardar</button>
					</div>
				</div>
			</div>
		</Modal>
	</div>
}
